<template>
  <v-card>
    <v-card-title class="py-0">
      <v-row>
        <v-col cols="5">
          <h6 v-if="label">{{label}}</h6>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="5">
          <WsDateRangePicker
            v-model="dateRange"
            :timeMode="timeMode"
          ></WsDateRangePicker>
        </v-col>
      </v-row>
    </v-card-title>
    <v-flex
      v-if="trending"
      style="height:250px"
      justify-center
      d-flex
      align-center
    >
      <p v-if="type=='pure_value'">{{unitPreText}} <span class="display-2">{{_number}}</span>{{unitAfterText}}</p>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    dateRange: {},
  }),
  methods: {
    getDateRange() {
      return this.dateRange;
    },
  },
  computed: {
    _number() {
      let _number = 0;
      let total = 0;
      let start = this.$moment(this.dateRange.start);
      let end = this.$moment(this.dateRange.end);
      let days_count = this.$moment.duration(end.diff(start)).asDays() + 1;
      for (let i = 0; i < days_count; i++) {
        let tarDate = this.$moment(start).add(i, "days");
        let tarDateText = tarDate.format("YYYY-MM-DD");
        if (this.trending[tarDateText]) {
          _number += this.trending[tarDateText];
          total++;
        }
      }
      if (this.calc_mode == "data_average") {
        _number /= total;
      } else if (this.calc_mode == "date_average") {
        _number /= days_count;
      }

      return this.$numeral(_number).format("0,0");
    },
  },
  watch: {
    dateRange: {
      handler() {
        this.$emit("date-range-update", this.dateRange);
      },
    },
  },
  props: {
    type: {
      type: String,
      default: "pure_value",
    },
    timeMode: {
      type: String,
      default: "7days",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    calcMode: {
      type: String,
      default: "amount",
    },
    trending: {
      type: Object,
      default: null,
    },
    unitPreText: {
      type: String,
      default: null,
    },
    unitAfterText: {
      type: String,
      default: null,
    },
  },
};
</script>

<style>
</style>